import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

function SidebarLayout() {
  return (
    <>
      <div className="font-Inter container max-w-full flex-1 h-full overflow-y-hidden bg-[#F5F7FC]">
        <div className="flex h-full">
          <Sidebar />
          <Outlet />
        </div>
      </div>
    </>
  );
}
export default SidebarLayout;
